var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graphic-template"},[_c('div',{staticClass:"graphic-template__header"},[_vm._v(" Archiwum ")]),_c('div',{staticClass:"graphic-template__content"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('ProjectCard',{attrs:{"project":_vm.project,"deletable":false}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }